import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  completeKYCSuccess,
  completeKYCFailure,
} from "../../Action/kyc/completeKYCAction";
import { COMPLETE_KYC } from "../../Action/actionTypes";
import toast from "react-hot-toast";
import { loginSuccess } from "../../Action/auth/loginAction";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../../Utils/Helper";

export const notifyPromise = (promise) => {
  return toast.promise(
    promise.then((res) => {
      if (res?.data?.meta?.code === 200) {
        return res;
      } else {
        throw { response: res };
      }
    }),
    {
      loading: "Submittig your documents...",
      success: (res) =>
        `${res?.data?.meta?.message || "Submitted successfully."}`,
      error: (err) =>
        `${err?.response?.data?.meta?.message || "Submission failed"}`,
    }
  );
};

function* completeKYCRequest(action) {
  try {
    const { data } = yield notifyPromise(
      API.post("/completekyc", action?.payload?.payload)
    );
   
    // Call the callback function if provided
    if (action?.payload?.callback) {
     
      yield call(action.payload.callback, data);
    }

    if (data?.meta?.code === 200) {
      yield put(completeKYCSuccess(data?.data));
      let localData = getLocalStorageItem("userData");
      if (localData) {
        localData.kyc_status = 2;
        yield put(loginSuccess(localData));
        yield call(setLocalStorageItem, "userData", JSON.stringify(localData));
      }
    } else {
      yield put(completeKYCFailure());
    }
  } catch (error) {
    // Call the callback function with error if provided
    if (action?.payload?.callback) {
      yield call(action.payload.callback, { error: true, message: error.message });
    }
    yield put(completeKYCFailure());
  }
}

export function* watchCompleteKYCAPI() {
  yield takeEvery(COMPLETE_KYC, completeKYCRequest);
}

export default function* rootSaga() {
  yield all([watchCompleteKYCAPI()]);
}